<template>
    <tr v-if="Boolean(o) === Boolean(n)">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td></td>
                    <td>
                        <label>
                            <input type="checkbox" v-model="res">
                            <span>{{ label }}</span>
                        </label>
                    </td>
                    <td></td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': Boolean(res) === Boolean(o)}" style="padding: 0 5px;">
            <a @click="res = o">
                <i class="far fa-square-check-o" v-if="Boolean(o) === true"></i>
                <i class="fa fa-square-o" v-if="Boolean(o) === false"></i>
                {{ label }}
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td></td>
                    <td>
                        <label>
                            <input type="checkbox" v-model="res">
                            <span>{{ label }}</span>
                        </label>
                    </td>
                    <td></td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': Boolean(res) === Boolean(n)}" style="padding: 0 5px;">
            <a @click="res = n">
                <i class="far fa-square-check-o" v-if="Boolean(n) === true"></i>
                <i class="fa fa-square-o" v-if="Boolean(n) === false"></i>
                {{ label }}
            </a>
        </td>
    </tr>
</template>
<script>
import Base from "../Base.vue";

export default {
    mixins: [Base],
    props: {
        o: {
            type: Number | Boolean,
            default: 0
        },
        n: {
            type: Number | Boolean,
            default: 0
        },
        f: {
            type: Number | Boolean,
            default: 0
        },
    },
    data: function () {
        return {
            label: this.params.label ?? '',
        }
    }
}
</script>